import { EContactDetailTypes, TConfirmPhone } from '../index';
import { EVerificationStatus } from '../initialState';

export const setConfirmedPhone = (phone: string): TConfirmPhone => ({
    type: EContactDetailTypes.SET_CONFIRMED_PHONE,
    payload: {
        confirmedPhone: {
            phone,
            status: EVerificationStatus.verified,
        },
    },
});
